export const DUMMY_FILTER_KEY = "dummy_filter_key";

export const excludeKeys = [DUMMY_FILTER_KEY];
export const SEPARATOR = "||";
